if (!('URLPattern' in globalThis)) await import('urlpattern-polyfill')
if (!('navigation' in globalThis)) await import('@virtualstate/navigation/polyfill')

export {}
